import { useEffect, useState } from "react";

const FnTableItemComponent = ({
  data,
  onSelectionChange,
  onEdit,
  onDelete,
}) => {
  const [rows, setRows] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);

  // Handle selected rows
  useEffect(() => {
    const selectedIds = rows
      .filter((r) => r.isChecked)
      .map((r) => r.Id);

    onSelectionChange?.(selectedIds);
  }, [rows, onSelectionChange]);

  // Prepare contest data
  useEffect(() => {
    if (!data) return;

    const prepared = data.map((contest) => ({
      ...contest,
      isChecked: false,
    }));

    setRows(prepared);
  }, [data]);

  const handleEdit = (id) => {
    onEdit?.(id);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this contest?")) {
      onDelete?.(id);
    }
  };

  return (
    <div>
      <table className="table table-bordered" width="100%">
        <thead>
          <tr>
            <th>Id</th>
            <th>Contest Name</th>
            <th>Contest Size</th>
            <th>Entry Fee</th>
            <th>Winning Amount</th>
            <th>Min Contest Size</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan="7" className="text-center">
                No contests available
              </td>
            </tr>
          ) : (
            rows.map((contest) => (
              <tr key={contest.Id}>
                <td>{contest.Id}</td>
                <td>{contest.contest_name}</td>
                <td>{contest.contest_size}</td>
                <td>{contest.entry_fee}</td>
                <td>{contest.winning_amount}</td>
                <td>{contest.min_contest_size}</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary mr-2"
                    onClick={() => handleEdit(contest.Id)}
                  >
                    Edit
                  </button>

                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(contest.Id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FnTableItemComponent;
